import { baseStyles } from './base.js';
import { changelogStyles } from './changelog.js';
import { componentsStyles } from './components.js';
import { designTokens } from './design-tokens.js';
import { feedbackStyles } from './feedback.js';
import { messengerStyles } from './messenger.js';
import { surveyStyles } from './survey.js';

export const CSS_STYLES =
	designTokens +
	baseStyles +
	componentsStyles +
	feedbackStyles +
	changelogStyles +
	surveyStyles +
	messengerStyles;

export {
	baseStyles,
	changelogStyles,
	componentsStyles,
	designTokens,
	feedbackStyles,
	messengerStyles,
	surveyStyles,
};
